import "./App.css";
import RouteMaster from "./routes/RouteMaster";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { AlertProvider } from "./contexts/AlertContext";
import { ModalProvider } from "./contexts/ModalContext";
import { DialogProvider } from "./contexts/DialogContext";
import { SocketProvider } from "./contexts/SocketContext";
import { SocketPendingProvider } from "./contexts/SocketPendingContext";
import { ReadQueueProvider, useReadQueue } from "./contexts/ReadQueueContext";
import { Font } from "@react-pdf/renderer";
import { useState } from "react";

Font.register({
  family: "Helvetica-Bold",
  src: "https://res.cloudinary.com/joeldes/raw/upload/v1741814243/JetStart/mqxjoqfinzsp7hqb3tgs.ttf",
});

function App() {
  return (
    <BrowserRouter>
      <ContextContainer>
        <RouteMaster />
      </ContextContainer>
    </BrowserRouter>
  );
}

const ContextContainer = ({ children }) => {
  return (
    <AuthProvider>
      <AlertProvider>
        <DialogProvider>
          <ModalProvider>
            <SocketProvider>
              <SocketPendingProvider>
                <ReadQueueProvider>
                  <GlobalReadQueueBarrier />
                  {children}
                </ReadQueueProvider>
              </SocketPendingProvider>
            </SocketProvider>
          </ModalProvider>
        </DialogProvider>
      </AlertProvider>
    </AuthProvider>
  );
};

const GlobalReadQueueBarrier = () => {
  const { queue, pendingCount, isProcessing } = useReadQueue();
  const [isOpen, setIsOpen] = useState(false);
  const hasActiveTasks = queue.some(
    (item) => item.status === "pending" || item.status === "running"
  );
  const hasQueueItems = queue.length > 0;

  if (!hasActiveTasks || !hasQueueItems) return null;

  return (
    <div className="fixed left-4 top-4 z-[999]">
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center gap-2 rounded-full border border-slate-200 bg-white/95 px-3 py-2 text-sm font-semibold text-[#1c3144] shadow-lg backdrop-blur"
      >
        <i className="fa-solid fa-file-import"></i>
        <span>Procesando</span>
        {pendingCount > 0 ? (
          <span className="rounded-full bg-[#ffc700] px-2 py-0.5 text-xs text-[#1c3144]">
            {pendingCount}
          </span>
        ) : null}
      </button>

      {isOpen ? (
        <div className="mt-2 w-[320px] rounded-2xl border border-slate-200 bg-white/95 p-4 shadow-2xl backdrop-blur">
          <div className="flex items-center justify-between text-[#1c3144]">
            <div className="flex items-center gap-2">
              <i className="fa-solid fa-file-import"></i>
              <h3 className="text-sm font-semibold">Procesando documentos</h3>
            </div>
            <button onClick={() => setIsOpen(false)} className="text-slate-500">
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
          <p className="mt-2 text-sm text-slate-600">
            La extracción sigue en segundo plano. Puedes seguir trabajando.
          </p>
          <div className="mt-3 rounded-xl bg-slate-50 p-3 text-sm text-slate-700">
            <div className="font-medium">
              {isProcessing ? "Procesando en curso" : "Pendiente por iniciar"}
            </div>
            <div className="mt-1">Documentos pendientes: {pendingCount}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default App;
